import { imageCoverContainer, imageWrapperPreserveRatio } from '@helpers/aspectRatio';
import { Device, from } from '@helpers/media';
import styled from 'styled-components';
const Container = styled.div `
  ${imageWrapperPreserveRatio(347, 231)};

  border-radius: 4px;
  margin-bottom: auto;

  @media ${from(Device.DesktopSmall)} {
    max-width: 439px;
  }
`;
const Image = styled.img `
  ${imageCoverContainer()};
`;
const NavigationImageStyles = { Container, Image };
export default NavigationImageStyles;
